import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  ICurriculum,
  ICurriculumForHome,
  ISearchOption,
  ISubjectMapDataForSubjectCode,
} from '.';
import { ApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';

export interface IGetSubjectMapDataBySubjectCode {
  subjectCode: string;
}

const CurriculumApiDataProvider = new APIDataProvider<ICurriculum>();
const CurriculumForHomeApiDataProvider = new APIDataProvider<ICurriculumForHome>();
const SearchOptionsForHomeApiDataProvider = new APIDataProvider<ISearchOption>();
const SubjectMapDataForSubjectCodeApiDataProvider = new APIDataProvider<ISubjectMapDataForSubjectCode>();

export const getCurriculums = createAsyncThunk('curriculum/list', async () => {
  const response = await CurriculumApiDataProvider.get(ApiPaths.curriculums);
  return response.data as Array<ICurriculum>;
});

export const getCurriculumsForHomePage = createAsyncThunk(
  'curriculum/getCurriculumsForHomePage',
  async () => {
    const response = await CurriculumForHomeApiDataProvider.get(
      `${ApiPaths.curriculums}/getCurriculumsForHomePage`
    );

    return response.data as Array<ICurriculumForHome>;
  }
);

export const getSubjectMapDataBySubjectCode = createAsyncThunk(
  'curriculum/subjectMapData',
  async (data: IGetSubjectMapDataBySubjectCode) => {
    const response = await SubjectMapDataForSubjectCodeApiDataProvider.create(
      `${ApiPaths.curriculums}/subjectMapDataForSubjectCode`,
      data
    );

    return response.data;
  }
);

export const getSearchOptionsForHomePage = createAsyncThunk(
  'curriculum/getSearchOptionsForHomePage',
  async () => {
    const response = await SearchOptionsForHomeApiDataProvider.get(
      `${ApiPaths.curriculums}/getSearchOptionsForHomePage`
    );

    return response.data as Array<ISearchOption>;
  }
);

export default getCurriculums;
